module.exports = __webpack_public_path__ + "media/images/sp/top/recommend_plan_photowedding-f5eb18d01d6c52b78fb1cd1c8ec55f93.webp";